/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from "react";
import { Link, withRouter } from "react-router-dom";
import LanguageSelector from "components/widgets/language/LanguageSelector";
import MobileMenu from "components/header/MobileMenu";
import Guidebar from "components/header/Guidebar";
import Notificationsbar from "components/header/Notificationsbar";
import Profilebar from "components/header/Profilebar";
import Navigation from "components/header/Navigation"; 
import { SCORMURL, ENV_NAME } from "util/constant";

import ExperienceBadge from "components/ExperienceBadge/ExperienceBadge"; // yeni import


class Header extends Component {
  state = { isMobileMenuVisible: false };

  unlisten = this.props.history.listen((location, action) => {
    if (location.pathname !== this.state.prevPath) {
      this.setState({ isMobileMenuVisible: false });
    }
  });

  toggleButton = React.createRef();

  componentDidMount() { }

  componentWillUnmount = () => {
    this.unlisten();
  };

  toggleMobileMenu = () => {
    if (this.state.isMobileMenuVisible) {
      this.setState({ isMobileMenuVisible: false });
    } else {
      this.setState({ isMobileMenuVisible: true });
    }
  };

  renderMobileMenu = () => {
    if (this.toggleButton.current) {
      if (this.state.isMobileMenuVisible) {
        this.toggleButton.current.classList.add("open");
        return <MobileMenu />;
      } else {
        this.toggleButton.current.classList.remove("open");
        return null;
      }
    }
  };

  renderVirtual = () => {

    // let url = ""; 

        const postUrl = `${SCORMURL}/index?env=${ENV_NAME}`;
            
                    const payload = {
                      employeeCode: "UnlsQ0hxRiswb3B1RjBTcFJwL3RFQkhBRFVyWTVRU3IyWUJXTmF4cEFqaTZVUFVrLzcyenlCNUlML25MaUttWg",
                      registeredTrainingId: "b69125e2-0556-ee11-be6e-000d3a2eabf5",
                      langCode: "1055",
                    };
            
                    // url = (
                    //   <span
                    //     className="iconmford fo-icon-play-circle-outline"
                    //     style={{ cursor: "pointer" }}
                    //     onClick={() => {
                    //       const newWindow = window.open(postUrl, "_blank");
            
                    //       // alıcı hazırım deyince gönder
                    //       const readyListener = (e) => {
                    //         if (e.data === "SCORM_READY") {
                    //           newWindow.postMessage(payload, SCORMURL);
                    //           window.removeEventListener("message", readyListener);
                    //         }
                    //       };
            
                    //       window.addEventListener("message", readyListener);
                    //     }}
                    //   />
                    // );

    if (localStorage.getItem("token") != null) {
      return (
        <>
        
          <a style={{ color: "white", fontWeight: "bold", marginBottom: "3px", cursor: "pointer" }} title="Sanal Tur" target="blank"
           onClick={() => {
                          const newWindow = window.open(postUrl, "_blank");
            
                          // alıcı hazırım deyince gönder
                          const readyListener = (e) => {
                            if (e.data === "SCORM_READY") {
                              newWindow.postMessage(payload, SCORMURL);
                              window.removeEventListener("message", readyListener);
                            }
                          };
            
                          window.addEventListener("message", readyListener);
                        }}
                         >
{/* href="https://fga-scorm.genbil.com/index?employeeCode=UnlsQ0hxRiswb3B1RjBTcFJwL3RFQkhBRFVyWTVRU3IyWUJXTmF4cEFqaTZVUFVrLzcyenlCNUlML25MaUttWg&registeredTrainingId=b69125e2-0556-ee11-be6e-000d3a2eabf5&langCode=1055&env=akademi" */}
            {/* <img
              src="/img/360-degrees.png"
              className="img-fluid"
              alt="Ford Logo" width="40px" height="35px"
            /> */}

            <span className="iconmford fo-icon-3d-rotation"></span>

            {/* <i class="fas fa-map-marked-alt fa-555lg" style={{ fontSize: "1.7em;" }}></i> */}
            {/* <i class="fas fa-route fa-555lg" style={{ fontSize: "1.7em;" }}></i> */}
            {/* <i class="fas fa-map-marker-alt fa-555lg" style={{ fontSize: "1.7em;" }}></i> */}
            {/* <i class="fas fa-globe fa-555lg" style={{ fontSize: "1.7em;" }}></i> */}
          </a>
        </>
      );
    }
  };

  render() {



    return (
      <>
        <header>
          <div className="container">
            <div className="row align-items-center">
              <div className="col-5 col-sm-5 col-md-3 col-lg-3 col-xl-2 logoArea">
                <Link to="/">
                  <img
                    src="/img/ford-gelisim-akademi-logo.png"
                    className="img-fluid"
                    alt="Ford Gelişim Akademi"
                    style={{ marginBottom: "-4%" }}
                  />
                </Link>
              </div>
              <Navigation />
              <div className="col-7 col-sm-7 col-md-4 col-lg-4 col-xl-5 topMenuNatficationArea">
                <ul className="notif">
                  <li>
                    {this.renderVirtual()}
                  </li>
                  <li>
                    <Guidebar />
                  </li>
                  <li className="natificationSubMenu">
                    <Notificationsbar />
                  </li>
                  <li>
                    <ExperienceBadge />
                  </li>
                  <li className="d-none d-md-block d-lg-block">
                    <Profilebar />
                  </li>
                  <LanguageSelector />
                  <li>
                    <div
                      className="menu-toggle"
                      id="menu-toggle"
                      ref={this.toggleButton}
                      onClick={this.toggleMobileMenu}
                    >
                      <span></span>
                      <span></span>
                      <span></span>
                      <span></span>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </header >
        {this.renderMobileMenu()}
      </>
    );
  }
}

export default withRouter(Header);
